import { Routes } from '@angular/router';
import { pmsDashboardRedirectGuard } from 'src/pms/guards/pms-dashboard-redirect.guard';

export const usaDashboardRoutes: Routes = [
  {
    path: 'dashboard',
    canActivate: [pmsDashboardRedirectGuard],
    loadComponent: () => import('./usa-dashboard.component').then((x) => x.UsaDashboardComponent),
    children: [
      {
        path: '',
        redirectTo: 'chat',
        pathMatch: 'full',
      },
      {
        path: 'chat',
        loadComponent: () => import('./chat-queue/chat-queue.component').then((x) => x.ChatQueueComponent),
      },
    ],
  },
];
